<script lang="ts">
  import DynamicBlock from '$components/blocks/dynamic-block.svelte';
  import CoverImage from '$components/cover-image.svelte';
  import CollectionDirectory from '$components/directory/collection-directory.svelte';
  import Seo from '$components/seo.svelte';
  import { categories } from '$lib/stores/content';
  import type { ISbStoryData } from '@storyblok/js';
  import type { ShopPageGroup } from './content';
  import type { ShopPageStoryblok } from '$types/bloks';
  import { cn } from '$lib/utils';
  import { buildPath } from '$lib/utils/paths';
  import CmsImage from '$components/cms-image.svelte';

  export let data: ShopPageGroup;

  const cover_image = data.story.content.cover_image;
  const pageTitle = data.story.content.page_title;
  const page_title = pageTitle || data.title || data.story.name;
  const sub_cols = (
    $categories.filter((c) => data.story.content.sub_collections.includes(c.uuid)) || []
  ).sort(
    (a, b) =>
      data.story.content.sub_collections.indexOf(a.uuid) -
        data.story.content.sub_collections.indexOf(b.uuid) || a.uuid.localeCompare(b.uuid)
  ) as ISbStoryData<ShopPageStoryblok>[];
  const handle = data.story.content.collection.toString();
  const shopifySEO = data.seo;
</script>

<Seo
  title={data.story.content.seo_title || shopifySEO?.title}
  description={data.story.content.seo_description || shopifySEO?.description}
  image={data.story.content.seo_og_image}
/>
<div class="[&>:last-child]:pb-2 lg:[&>:last-child]:pb-8">
  <CoverImage image={cover_image} title={page_title} />
  <section class="px-2 pt-2 lg:px-8 lg:pt-4 pb-4">
    <div class="container mx-auto">
      <div class="-mx-2 flex gap-2 overflow-auto pr-2 hide-scrollbar lg:-mx-8 lg:gap-4 lg:pr-8">
        {#each sub_cols as collection, i}
          <a
            href={$buildPath({
              path: collection.full_slug
            })}
            class={cn(
              'group relative flex h-20 lg:h-30 min-w-[114px] flex-1 items-center justify-center rounded-sm overflow-hidden border-none text-center text-lg font-semibold text-primary/96 shadow-none outline-none transition-all focus-visible:ring lg:min-w-[114px] bg-primary/4',
              i === 0 && 'ml-2 lg:ml-8'
            )}
          >
            <div
              class="absolute z-10 inset-0 bg-black/14 group-hover:opacity-0 transition-opacity"
            />
            {#if collection.content.cover_image?.filename}
              <CmsImage
                image={collection.content.cover_image}
                widths={[(w) => w]}
                options={{ size: [256, 120] }}
                sizes="25vw"
                class="absolute z-0 inset-0 w-full h-full object-cover"
              />
            {/if}
            <p class="z-20 text-highlight">
              {collection.name}
            </p>
          </a>
        {/each}
      </div>
    </div>
  </section>

  <CollectionDirectory
    collectionName={data.story.name}
    collectionHandle={handle}
    pageSize={data.pageSize}
    marketingItems={data.story.content.marketing_items}
  />

  {#if data.story.content.body}
    {#each data.story.content.body as block}
      <DynamicBlock {block} />
    {/each}
  {/if}
</div>
